module.exports = __webpack_public_path__ + "static/img/Coming_Home_FPO@3x.a83356f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/Coming_Home_FPO@3x.jpg
// module id = Gb6U
// module chunks = 0